export const isRevertDataOnExpandAndCollapse = true

export const SOB_SECTION = 'jbp-sob-v2'
export const OVERALL_CATEGORY = 'jbp-overall'

export const IS_COLLAPSED_FIELD = 'IsCollapsed'

export const IS_SHOW_APPLY_SECTION_HELP = false
export const IS_SHOW_VALUES_TOOLTIP = false
export const IS_CALC_OVERALL_FIELD = false

export const SOB_FRACTION_DIGITS = 1

export const IS_SOB_VALIDATION_ENABLED = true
